import React, { useEffect, useState } from 'react';
import {
  AutoComplete, Input, Select,
} from 'antd';
import { injectIntl } from 'react-intl';
import usePlacesAutocomplete, { getDetails } from 'use-places-autocomplete';
import { useSelector, useDispatch } from 'react-redux';
import { find, intersectionWith } from 'lodash';
import { Controller } from 'react-hook-form';
import { getPacientesPaises, getPacientesProvincias } from '../../../../state/actions/creators/pacientes.actioncreator';
import { formateaEsfera } from '../../../../helpers/modules/graduaciones.helper';
import ReadOnly from '../../../shared/components/dataEntry/ReadOnly';

const { Option } = Select;

interface contactInfoProps{
  camposDinamicos: any,
  hookForms:any,
  intl:any,
  handleChange:any,
  watch: boolean,
}

function ContactInfo({
  camposDinamicos, hookForms, intl, handleChange, watch,
}:contactInfoProps) {
  const {
    register, setValue, trigger, errors, control,
  } = hookForms;

  const fields = [
    'direccion', 'poblacion', 'pais', 'codigo_postal',
  ];
  const dispatch = useDispatch();

  const paisesList = useSelector((state: any) => state.pacientesWorkspace.paises);
  const provinciasList = useSelector((state: any) => state.pacientesWorkspace.provincias);
  const pacienteSelected = useSelector((state: any) => state.pacientesWorkspace.pacienteSelected);
  const [paisSelect, setPaisSelect] = useState('');
  const [provinciaState, setProvinciaState] = useState<string>();
  const [provinceSearchText, setProvinceSearchText] = useState<string>('');
  const provincias = provinciasList.filter((e:any) => e.descripcion.toLowerCase().includes(provinceSearchText.toLowerCase()));
  const cellRegister = ((elem: HTMLInputElement | HTMLTextAreaElement | null) => {
    if (watch && elem) elem.disabled = true;
    register(elem);
  });
  useEffect(() => {
    dispatch(getPacientesPaises());
  }, []);

  useEffect(() => {
    if (pacienteSelected) {
      const {
        direccion, pais, provincia, poblacion, codigo_postal,
      } = pacienteSelected;
      setValue('direccion', direccion);
      setValue('pais', pais);
      setValue('poblacion', poblacion);
      setValue('codigo_postal', codigo_postal);
      setPaisSelect(pais);
      setProvinciaState(provincia);
    }
  }, [pacienteSelected]);


  useEffect(() => {
    if (paisSelect && paisesList.length > 0) {
      const conversionACodigoPais = paisesList.find((e:any) => e.nombre === paisSelect);
      if (conversionACodigoPais) {
        const { idAlfa2 } = conversionACodigoPais;
        dispatch(getPacientesProvincias({ codigoPais: idAlfa2 }));
      } else {
        dispatch(getPacientesProvincias({ codigoPais: paisSelect }));
      }
    }
  }, [paisSelect, paisesList]);

  useEffect(() => {
    setValue('provincia', provinciaState);
  }, [provinciaState, provinciasList]);


  const [searchOptions, setSearchOptions] = useState([]);
  const {
    ready,
    suggestions: { data },
    setValue: setMapValue,
  } = usePlacesAutocomplete();

  const handleInputSearch = (value: string): void => {
    setMapValue(value);
    const suggestions: any = [];
    data.map(({ place_id, description }: any) => suggestions.push({ value: place_id, text: description }));
    if (ready) {
      setSearchOptions(suggestions);
    }
  };

  const handleSelect = (val: string): void => {
    const parameter = {
      placeId: val,
      fields: ['address_components'],
    };
    getDetails(parameter)
      .then((details: any) => {
        for (let i = 0; i < details.address_components.length; i += 1) {
          const addressComponent = details.address_components[i];
          for (let j = 0; j < addressComponent.types.length; j += 1) {
            const addressComponentType = addressComponent.types[j];
            switch (addressComponentType) {
              case 'route':
                if (i === 1) {
                  setValue('direccion', `${addressComponent.long_name} ${details.address_components[i - 1].long_name}`);
                } else {
                  setValue('direccion', `${addressComponent.long_name}`);
                }
                break;
              case 'locality':
                setValue('poblacion', addressComponent.long_name);
                break;
              case 'country':
                setValue('pais', addressComponent.long_name);
                const { idAlfa2 } = paisesList.find((e:any) => e.nombre === addressComponent.long_name);
                setPaisSelect(idAlfa2);
                break;
              case 'postal_code':
                setValue('codigo_postal', addressComponent.long_name);
                break;
              case 'administrative_area_level_2':
                setProvinciaState(addressComponent.long_name);
                break;
              case 'administrative_area_level_1':
              default:
                break;
            }
          }
        }
        trigger(['direccion', 'poblacion', 'provincia', 'pais', 'codigo_postal']);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const isAllHidden = () => {
    const intersections = intersectionWith(camposDinamicos, fields,
      (campoPersonalizado: any, field: string) => campoPersonalizado?.campo_descripcion === field
        && campoPersonalizado?.propiedades.visible === false);

    return intersections.length === fields.length;
  };

  const isHidden = (field: string) => {
    const campoPersonalizado = find(camposDinamicos,
      (campoPersonalizado: any) => campoPersonalizado.campo_descripcion === field);
    if (!campoPersonalizado) return false;
    return !campoPersonalizado.propiedades.visible;
  };


  return (
    <div className="bodyInfo flexCol" hidden={(() => isAllHidden())()}>
      <div className="inputMarginTop">
        <h3>{intl.formatMessage({ id: 'pacientes.generic.titles.contact_info' })}</h3>
        <div className="marginTop24">
          { !watch 
            && (
              <div>
                <p>{intl.formatMessage({ id: 'pacientes.generic.titles.search' })}</p>
                <div className="nameInputs">
                  <Input.Group>
                    <AutoComplete
                      getPopupContainer={(trigger: HTMLElement): any => (trigger.parentElement
                        ? trigger.parentElement : null)}
                      onSearch={value => handleInputSearch(value)}
                      onSelect={value => handleSelect(value.toString())}
                      dataSource={searchOptions}
                      id="searchAuto"
                      placeholder={intl.formatMessage({ id: 'pacientes.generic.titles.search_ph' })}
                      style={{ width: '100%' }}
                    />
                  </Input.Group>
                </div>
              </div>
            )
          }
        </div>
        {!isHidden('direccion') && (
        <div style={{ marginTop: '1px' }}>
          <p>{intl.formatMessage({ id: 'pacientes.generic.titles.direccion' })}</p>
          <div className="nameInputs">
            <input
              className={`ant-input ${errors.direccion ? 'input-border-error' : ''} ${watch ? 'disabledText' : ''}`}
              name="direccion"
              ref={cellRegister}
              style={{ width: '100%' }}
            />
            <div>
              {errors.direccion && (
              <p className="errors">{errors.direccion.message}</p>
              )}
            </div>
          </div>
        </div>
        )}
        <div className="contact">
          {!isHidden('poblacion') && (
          <div className="flexCol">
            <p>{intl.formatMessage({ id: 'pacientes.generic.titles.poblacion' })}</p>
            <div className="inputMarginTop">
              <input
                className={`ant-input ${errors.poblacion ? 'input-border-error' : ''} ${watch ? 'disabledText' : ''}`}
                name="poblacion"
                ref={cellRegister}
                style={{ width: '100%' }}
              />
              <div>
                {errors.poblacion && (
                <p className="errors">{errors.poblacion.message}</p>
                )}
              </div>
            </div>
          </div>
          )}
          {!isHidden('provincia') && (
          <div className="flexCol">
            <p>{intl.formatMessage({ id: 'pacientes.generic.titles.provincia' })}</p>
            <div className="inputMarginTop">
              <Input.Group>
                <Controller
                  control={control}
                  name="provincia"
                  render={
                      ({
                        name, onChange, value,
                      }) => (
                        <AutoComplete
                          dataSource={provincias.map((e:any) => e.descripcion)}
                          style={{ width: '100%' }}
                          className={watch ? 'disabledText' : ''}
                          disabled={watch}
                          defaultValue={pacienteSelected ? pacienteSelected.provincia : null}
                          value={value}
                          onSelect={(value:any) => handleChange(name, value)}
                          onChange={(value:any) => handleChange(name, value)}
                          onSearch={value => setProvinceSearchText(value)}
                          getPopupContainer={(trigger:HTMLElement): any => (trigger.parentElement
                            ? trigger.parentElement : null)}
                        />
                      )}
                />
              </Input.Group>
              <div>
                {errors.provincia && (
                <p className="errors">{errors.provincia.message}</p>
                )}
              </div>
            </div>
          </div>
          )}
        </div>
        <div className="contact">
          {!isHidden('codigo_postal') && (
          <div className="flexCol">
            <p>{intl.formatMessage({ id: 'pacientes.generic.titles.codigo_postal' })}</p>
            <div className="inputMarginTop">
              <input
                className={`ant-input ${errors.codigo_postal ? 'input-border-error' : ''} ${watch ? 'disabledText' : ''}`}
                name="codigo_postal"
                ref={cellRegister}
                style={{ width: '100%' }}
              />
              <div>
                {errors.codigo_postal && (
                <p className="errors">{errors.codigo_postal.message}</p>
                )}
              </div>
            </div>
          </div>
          )}
          {!isHidden('pais') && (
          <div className="flexCol">
            <p>{intl.formatMessage({ id: 'pacientes.generic.titles.pais' })}</p>
            <div className="inputMarginTop">
              <Input.Group>
                <Controller
                  control={control}
                  name="pais"
                  render={
                    ({
                      name, onChange, value,
                    }) => (
                      <Select
                        disabled={watch}
                        showSearch
                        className={`${errors.pais ? 'input-border-error' : ''} ${watch ? 'disabledText' : ''}`}
                        style={{ width: '100%' }}
                        getPopupContainer={(trigger:HTMLElement): any => (trigger.parentElement
                          ? trigger.parentElement : null)}
                        onSelect={(value:string) => { handleChange(name, value); setPaisSelect(value); }}
                        filterOption={(input, option:any) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                        value={value}
                      >
                        {paisesList.map((pais:any) => <Option key={pais.idAlfa2} value={pais.idAlfa2}>{pais.nombre}</Option>)}
                      </Select>
                    )}
                />
              </Input.Group>
              <div>
                {errors.pais && (
                <p className="errors">{errors.pais.message}</p>
                )}
              </div>
            </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default injectIntl(ContactInfo);
